<template><div><h2>捐赠</h2>
<ul>
<li><a href="https://www.patreon.com/airyland">Patreon</a></li>
<li><a href="https://paypal.me/airyland">PayPal</a></li>
<li>支付宝 airyland@qq.com</li>
</ul>
</div></template><script>
export default {
  head: {"title":"捐赠支持 VUX | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// donate-149.vue?556653cf